import { GTMEvent } from '../GTM'
import { isValidProductItemData } from './pushPdp'
import { formatPrice } from '@corratech/pylot-seo'

export const pushProductClick = (data: Record<string, unknown>): GTMEvent => {
    if (!isValidProductItemData(data)) {
        console.info('Invalid GTM product click data')
        return { event: '' }
    }

    const { category, id, name, price, currencyCode, product_type } = data
    return {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: category
                },
                products: [
                    {
                        id: id,
                        name: name,
                        price: formatPrice(price),
                        currency_code: currencyCode,
                        product_type: product_type,
                        category: category
                    }
                ]
            }
        },
        _clear: true
    }
}
